import { MeshProps, ThreeEvent, useFrame, useThree } from '@react-three/fiber';
import { SkeletonBounds, SkeletonMesh } from '@esotericsoftware/spine-threejs';
import { MathUtils } from 'three';
import { useEffect } from 'react';
import DamselClass from '../classes/Damsel';
import { Tool, ToolLocation } from '../classes/ToolFactory';


type DamselProps = {
  damsel: DamselClass,
  tool?: Tool | null,
  onRegionClick?: Handler
} & MeshProps

type Handler = (location: ToolLocation) => void


// due to bug ? Type error
type CustomVector3 = SkeletonMesh['position']

// Hook
function useTargetClick(mesh: DamselClass, handler?: Handler) {

  return (e: ThreeEvent<MouseEvent>) => {
    if(!handler) {
      return
    }   
    const bounds = new SkeletonBounds()
    bounds.update(mesh.skeleton, false)
    const v = mesh.worldToLocal(e.point as unknown as CustomVector3)
    const result = bounds.containsPoint(v.x, v.y)
    if(result) {
      handler(result.name as ToolLocation)
    }
  }

}

const eyeXRange = [-6, 6]
const eyeYRange = [-9, 9]
function useEyeMovement(mesh: SkeletonMesh) {
  const three = useThree()

  useEffect(() => {
    if(!mesh) {
      return
    }
    const { left: cx, top: cy } = three.gl.domElement.getBoundingClientRect()
    const w2 = three.size.width / 2
    const h2 =  three.size.height / 2

    const bone = mesh.skeleton.findBone('eyes-center')

    // console.log("bone", bone)

    function onMouseMove(e: MouseEvent) {
      if(!bone) {
        return
      }

      // not right ? sort works ?
      // might not work with real body movement ?
      const x = e.clientX - cx - w2 
      const y = e.clientY - cy - h2
      const dx = MathUtils.clamp(MathUtils.mapLinear(x, -w2, w2, eyeXRange[0], eyeXRange[1]), eyeXRange[0], eyeXRange[1])
      const dy = MathUtils.clamp(MathUtils.mapLinear(y, -h2, h2, eyeYRange[0], eyeYRange[1]), eyeYRange[0], eyeYRange[1])
      // questionable
      bone.x = bone.data.x - dy
      bone.y = bone.data.y - dx
    }
    window.addEventListener('mousemove', onMouseMove)

    return () => window.removeEventListener('mousemove', onMouseMove)

  }, [mesh, three])
}

function useRandomBlinks(damsel: DamselClass) {
  useEffect(() => {
    let i = setInterval(() => {
      if(Math.random() < 0.33) {
        damsel.blink()
      }
    }, 1000)
    return () => clearInterval(i)
  }, [damsel])
}

function Damsel({ damsel, onRegionClick }: DamselProps) {

  const onClick = useTargetClick(damsel, onRegionClick)
  useEyeMovement(damsel)
  useRandomBlinks(damsel)

  useFrame((_, delta) => {
    damsel.update(delta)
  })      

  return <primitive object={damsel} onClick={onClick} {...damsel.getMeshOptions()} />
}

export default Damsel